import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useEffect } from "react";
import "../management/ManagementModal.scss";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function ViewBrand({ openBrand, close, brandData }) {
    const [brandName, setBrandName] = React.useState("");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setBrandName(brandData?.brandName)
    }, [brandData]);

    return (
        <div>
            <BootstrapDialog
                className="management-modal-wrap modal-wrap"
                onClose={() => close()}
                aria-labelledby="customized-dialog-title"
                open={openBrand}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={() => close()}
                >
                    View Brand
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    id="outlined-required"
                                    fullWidth
                                    label="Brand Name"
                                    value={brandName}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="btns-wrapper btn-padding">
                    <Stack spacing={4} direction="row" className="bottom-btn-wrap">
                        <Button variant="outlined" onClick={() => close()}>Cancel</Button>
                    </Stack>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
